export default __webpack_public_path__ + "static/media/api.3c0992bf.svg";